// test1302
(1302 && 0);
